import { useEffect } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import MontazPage from "./pages/MontazPage";
import FotowoltaikaPage from "./pages/FotowoltaikaPage";
import PrzykladStronyPage from "./pages/PrzykladStronyPage";
import AgencyHomePage from "./pages/AgencyHomePage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Skip if URL has a hash anchor (let the browser handle in-page scroll)
    if (typeof window === "undefined") return;
    if (window.location.hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  // Remove the Emergent badge if present
  useEffect(() => {
    const remove = () => {
      const el = document.getElementById("emergent-badge");
      if (el && el.parentNode) el.parentNode.removeChild(el);
    };
    remove();
    const t = setInterval(remove, 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="App font-body bg-white text-slate-900 antialiased">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<AgencyHomePage />} />
          <Route path="/cena" element={<LandingPage />} />
          <Route path="/montaz" element={<MontazPage />} />
          <Route path="/fotowoltaika" element={<FotowoltaikaPage />} />
          <Route path="/przyklad-strony" element={<PrzykladStronyPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
